import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Logo from "@/components/Logo";
import { CheckCircle2, XCircle, ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { FindoSpinner } from "@/components/FindoSpinner";

export default function ReclamationSecours() {
  const { t } = useLang();
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    api(`/public/rescue-claim/${encodeURIComponent(token)}`, { auth: false })
      .then((r) => {
        setState("ok");
        setTimeout(() => navigate(r.resume_url || "/mon-compte"), 1800);
      })
      .catch((e) => { setState("error"); setMessage(e.message || t("hc.invalidOrExpiredLink")); });
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-findo-cream">
      <header className="border-b border-findo-navy/10 bg-white/80 backdrop-blur">
        <div className="max-w-2xl mx-auto px-5 py-4"><Link to="/"><Logo /></Link></div>
      </header>
      <main className="max-w-lg mx-auto px-5 py-20">
        {state === "loading" && (
          <div className="bg-white rounded-2xl border border-border p-8 text-center card-shadow" data-testid="rescue-loading">
            <FindoSpinner size={34} className="mx-auto mb-3" />
            <h1 className="font-display font-bold text-xl text-findo-navy">{t("hc.verifyingTheLink")}</h1>
          </div>
        )}
        {state === "ok" && (
          <div className="bg-white rounded-2xl border border-border p-8 text-center card-shadow" data-testid="rescue-ok">
            <CheckCircle2 className="mx-auto text-emerald-500 mb-3" size={44} />
            <h1 className="font-display font-bold text-xl text-findo-navy mb-2">{t("hc.ownershipConfirmed")}</h1>
            <p className="text-slate-500 text-sm flex items-center justify-center gap-1.5">
              <ShieldCheck size={15} /> {t("hc.redirectingToTheRecoveryOf")}
            </p>
          </div>
        )}
        {state === "error" && (
          <div className="bg-white rounded-2xl border border-border p-8 text-center card-shadow" data-testid="rescue-error">
            <XCircle className="mx-auto text-red-500 mb-3" size={44} />
            <h1 className="font-display font-bold text-xl text-findo-navy mb-2">{t("hc.linkUnavailable")}</h1>
            <p className="text-slate-500 text-sm">{message}</p>
            <Link to="/mon-compte" className="mt-5 inline-flex rounded-full bg-findo-navy text-white font-semibold px-5 py-2.5 text-sm hover:bg-findo-navy/90 transition-colors">{t("hc.goToMyAccount")}</Link>
          </div>
        )}
      </main>
    </div>
  );
}
